import { FC, useCallback } from "react";

import { StartVisitModal } from "@/pages/WorkPlan/Tasks/StartVisit/StartVisitModal";
import { StartVisitModalWarning } from "@/pages/WorkPlan/Tasks/StartVisit/StartVisitModalWarning";

import { PointTasksModalState, PointTasksModalType } from "./PointTasks.types";
import { TaskProgressModal } from "./TaskProgressModal";

interface PointTasksModalsContainerProps {
    modal: PointTasksModalState;
    onChangeModal: (modal: PointTasksModalState) => void;
}

export const PointTasksModalsContainer: FC<PointTasksModalsContainerProps> = ({
    modal,
    onChangeModal,
}) => {
    const onCloseModal = useCallback(
        () => onChangeModal(null),
        [onChangeModal],
    );

    if (!modal) return null;

    const { type, payload } = modal;

    switch (type) {
        case PointTasksModalType.StartVisit:
            return (
                <StartVisitModal
                    payload={payload}
                    onCloseModal={onCloseModal}
                    onOpenWarningModal={(payload) =>
                        onChangeModal({
                            type: PointTasksModalType.StartVisitWarning,
                            payload,
                        })
                    }
                />
            );

        case PointTasksModalType.StartVisitWarning:
            return (
                <StartVisitModalWarning
                    payload={payload}
                    onCloseModal={onCloseModal}
                />
            );

        case PointTasksModalType.TaskProgress:
            return (
                <TaskProgressModal payload={payload} onClose={onCloseModal} />
            );

        default:
            return null;
    }
};
